import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useAutoformMetadata = () => {
    const metadata = useSelector((state) => state.autoform.metadata);

    const itemTypeId = useMemo(
        () => metadata?.parameters.find((parameter) => parameter?.name === 'ITEMTYPEID'),
        [metadata?.parameters]
    );

    const hierarchicalTables = useMemo(() => {
        if (!metadata)
            return {
                level1: [],
                level2: [],
                level3: [],
                level4: [],
            };
        return {
            level1: metadata.tables.filter((table) => table.level === 1),
            level2: metadata.tables.filter((table) => table.level === 2),
            level3: metadata.tables.filter((table) => table.level === 3),
            level4: metadata.tables.filter((table) => table.level === 4), // TODO: Add level 4
        };
    }, [metadata]);

    const tableMap = useMemo(() => {
        if (!metadata) return {};
        return metadata.tables.reduce((acc, item) => {
            acc[item.id] = item;

            return acc;
        }, {});
    }, [metadata]);
    return { metadata, hierarchicalTables, tableMap, itemTypeId };
};

export default useAutoformMetadata;
